/* eslint-disable */
import type { Abi, Address } from "viem"
import type { Config } from "wagmi"

import type { TransactionReturnType } from "../types"
import { simulatedTransaction } from "../simulated-transaction"

type MintGammaClFarmLiquidityProps = {
  account: Address
  chainId: number
  config: Config
  guardAddress: Address
  vaultAddress: Address
  token0AmountBI: bigint
  token1AmountBI: bigint
}

const depositAbi = [
  {
    inputs: [
      { internalType: "uint256", name: "deposit0", type: "uint256" },
      { internalType: "uint256", name: "deposit1", type: "uint256" },
      { internalType: "address", name: "to", type: "address" },
      { internalType: "address", name: "pos", type: "address" },
      { internalType: "uint256[4]", name: "minIn", type: "uint256[4]" },
    ],
    name: "deposit",
    outputs: [{ internalType: "uint256", name: "shares", type: "uint256" }],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const

export const mintGammaClFarmLiquidity = async ({
  account,
  chainId,
  config,
  guardAddress,
  vaultAddress,
  token0AmountBI,
  token1AmountBI,
}: MintGammaClFarmLiquidityProps): Promise<TransactionReturnType> => {
  try {
    const result = await simulatedTransaction({
      config,
      simulateArgs: {
        abi: depositAbi as Abi,
        account,
        chainId,
        address: guardAddress,
        functionName: "deposit",
        args: [token0AmountBI, token1AmountBI, account, vaultAddress, [0, 0, 0, 0]],
      },
    })

    return result
  } catch (error: any) {
    console.error("mintSteerClFarmLiquidity", error)
    return { success: false, error: error.message, code: error.code }
  }
}
